import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-agcharts-ent',
	templateUrl:'./AgChartsEnterprisePluginPage.html',
	styles: [],
	styleUrls:['./AgChartsEnterprisePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgChartsEnterprisePluginPage
{
	mdContent_43 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>agcharts-enterprise</artifactId>
</dependency>
\`\`\``;
	mdContent_44 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:agcharts-enterprise:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_45 = `\`\`\`json
"ag-charts-enterprise": "^13.1.0"
\`\`\``;
	mdContent_46 = `\`\`\`java
AgChartsEnterprisePageConfigurator
    .setAG_CHARTS_LICENSE_KEY("YOUR_KEY");

@NgComponent
public class DashboardGauge
        implements INgComponent<DashboardGauge> {
    public AgRadialGaugeOptions<DashboardGauge> gauge() {
        return new AgRadialGaugeOptions<>(this)
            .setValue(75.0)
            .setScale(new AgGaugeScale()
                .setMin(0).setMax(100));
    }
}
\`\`\``;
	mdContent_47 = `\`\`\`java
var chart = new AgCandlestickChart<>();
chart.getOptions()
    .setSeries(List.of(
        new AgCandlestickSeriesOptions<>()
            .setXKey("date")
            .setOpenKey("open")
            .setHighKey("high")
            .setLowKey("low")
            .setCloseKey("close")
    ));
\`\`\``;
	mdContent_48 = `\`\`\`java
// Set license key
AgChartsEnterprisePageConfigurator
    .setAG_CHARTS_LICENSE_KEY("YOUR_KEY");

@NgComponent
public class DashboardGauge
        implements INgComponent<DashboardGauge> {
    public AgRadialGaugeOptions<DashboardGauge> gauge() {
        return new AgRadialGaugeOptions<>(this)
            .setValue(75.0)
            .setScale(new AgGaugeScale()
                .setMin(0).setMax(100));
    }
}
\`\`\``;
}
